export default __webpack_public_path__ + "static/media/david3.182aa911.jpg";